import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ymvqmtdeonjpcvzxrqca.supabase.co';
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InltdnFtdGRlb25qcGN2enhycWNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ0NzU5MzEsImV4cCI6MjA4MDA1MTkzMX0.e5NwFYvjWbZIYacz0MOMAbbT2jyGH27_yHXbHt-J0Rc';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase Environment Variables');
}

// 💾 STORAGE ACCESSIBILITY CHECK
try {
  const testKey = '__storage_test__';
  window.sessionStorage.setItem(testKey, testKey);
  window.sessionStorage.removeItem(testKey);
  console.log("💾 STORAGE CHECK: sessionStorage is accessible");
} catch (e) {
  console.error("💾 STORAGE CHECK: sessionStorage is BLOCKED! Supabase Auth may hang.", e);
}

console.log("Supabase Client Initializing with URL:", supabaseUrl);
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.sessionStorage, // Forces session to die when tab closes
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Proactive Connectivity Check
supabase.from('profiles').select('id', { count: 'exact', head: true }).limit(1)
  .then(({ error }) => {
    if (error) {
      console.error("🌐 SUPABASE CONNECTIVITY CHECK: ❌ FAILED", error.message);
      console.error("🌐 ERROR CODE:", error.code, "HINT:", error.hint);
    } else {
      console.log("🌐 SUPABASE CONNECTIVITY CHECK: ✅ OK");
    }
  })
  .catch(err => {
    console.error("🌐 SUPABASE CONNECTIVITY CHECK: 💥 CRASHED", err);
  });